import styled from "styled-components";

const Subtitle = styled.h1.attrs(props => ({
    className: props.sb ? 'subtitle-sb' : 'subtitle',
}))`
    color: ${props => props.color}
`
export default Subtitle;
